import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useCurrency(userId) {
  const { data, mutate } = useSWR(
    userId ? `/currencies/` : null,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  return {
    currency: data,
    mutate: mutate,
  };
}

export default useCurrency;
